let fetchFuc = (url, method, body) => {
  if (method === 'GET') {
      return fetch(url,{
          method: method,
          headers: {
              'Authorization': "bearer " + localStorage.getItem('access_token'),
              'StoreId': localStorage.getItem('current_store_id')
          }
      })
  } else if (method === 'GETALL') {
      return fetch(url,{
          method: 'GET',
          headers: {
              'Authorization': "bearer " + localStorage.getItem('access_token'),
              'StoreId': '0'
          },
          body: body
      })
  } else if (method === 'POST') {
    return fetch(url,{
        method: method,
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': "bearer " + localStorage.getItem('access_token'),
            'StoreId': localStorage.getItem('current_store_id')
        },
        body: body
    })
    } else if (method === 'PATCH') {
      return fetch(url,{
          method: method,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': "bearer " + localStorage.getItem('access_token'),
            'StoreId': localStorage.getItem('current_store_id')
          },
          body: body
      })
  } else if (method === 'PUT') {
      return fetch(url,{
          method: method,
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': "bearer " + localStorage.getItem('access_token'),
            'StoreId': localStorage.getItem('current_store_id')
          },
          body: body
      })
  } else if (method === "DELETE") {
      return fetch(url,{
          method: 'DELETE',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': "bearer " + localStorage.getItem('access_token'),
            'StoreId': localStorage.getItem('current_store_id')
          },
          body: body
      })
  }else {
      return fetch(url)
  }
}

export default fetchFuc;